import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Checkbox from '@afosto/app-components-react/Checkbox';
import DateTimePicker from '@afosto/app-components-react/DateTimePicker';
import translations from './translations';

const PricingAtFormSection = ({ onChange, onBlur, showApplyPricingRulesOption, value }) => {
  const intl = useIntl();

  return (
    <Card style={{ marginBottom: 8 }}>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <DateTimePicker
          name="pricingAt"
          label={intl.formatMessage(translations.fields.pricingAt.label)}
          onChange={onChange}
          onBlur={onBlur}
          register={false}
          value={value}
          disableFuture={false}
        />
        {showApplyPricingRulesOption && (
          <Box mt={1}>
            <Checkbox
              name="applyPricingRules"
              label={intl.formatMessage(translations.fields.applyPricingRules.label)}
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

PricingAtFormSection.propTypes = {
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  showApplyPricingRulesOption: PropTypes.bool,
  value: PropTypes.string,
};

PricingAtFormSection.defaultProps = {
  onBlur: undefined,
  onChange: undefined,
  showApplyPricingRulesOption: false,
  value: undefined,
};

export default PricingAtFormSection;
